define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Heading",
	"csi/heading/RefContainer",
	"csi/reflection",
	"csi/types"
], function(declare,lang,Heading,RefContainer,reflection,types) {

	var _subHeading = lang.mixin(new Heading(), {
		m_format: types.FORMAT_IMAGE,
		m_id: reflection.ATTR_THUMBNAIL
	});

	return declare(RefContainer, {
		// Boolean: don't sort images by name
		bSort: false,

		canBeLarge: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return 1 as a list of images could get large
			return 1;
		},

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render thumbnail in smallest size
			var imageSizeOld = ctx.prefImageSize;
			ctx.prefImageSize = reflection.IMAGE_SIZE_SMALLEST;
			var ret = this.inherited(arguments);
			ctx.prefImageSize = imageSizeOld;
			return ret;
		},

		_getCSS: function(/*String*/type, /*String?*/format) {
			// summary: return class to separate images
			return "csiNodeImages";
		},

		_getSeparator: function(/*Heading*/h) {
			// summary: return empty string - CSS will provide separation
			return "";
		},

		_getSubHeadingToRender: function(/*Heading*/h) {
			// summary: return heading to render thumbnail
			return this.inherited(arguments) || _subHeading;
		}
	});
});